<div
  class="ui segment"
  style="
    padding-left: 0px;
    padding: 10px;
    margin-bottom: 10px;
    border: 0px;
    margin-top: 20px;
  "
>
  <div
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    style="margin-bottom: 0px; margin-top: 20px"
  >
    <div fxFlex="20%" style="align-self: center" class="table-data">
      <h1>Document Title</h1>
      <p style="text-transform: capitalize">
        {{ application?.name }}
      </p>
    </div>

    <div fxFlex="20%" style="align-self: center" class="table-data">
      <h1>Description</h1>
      <p>{{ application?.description }}</p>
    </div>

    <div fxFlex="20%" style="align-self: center" class="table-data">
      <h1>Date Created</h1>
      <p>{{ application?.dateCreated | date: "d, MMMM y, h:mma" }}</p>
    </div>
    <div fxFlex="20%" style="align-self: center" class="table-data">
      <h1>Created By</h1>
      <p>{{ application?.createdBy | createdBy }}</p>
    </div>
    <div fxFlex="20%" style="align-self: center" class="table-data">
      <div class="ui mini basic primary dropdown" suiDropdown>
        <img src="assets/icons/Button.svg" alt="" />
        <div class="left menu" suiDropdownMenu>
          <div class="item" *ngIf="!disabled" (click)="edit.emit(application)">
            Edit Document
          </div>
          <div class="item" (click)="onView.emit(application)">
            View Document
          </div>
          <div
            class="item"
            *ngIf="!disabled"
            (click)="deleteAssessment.emit(application.aolDocumentId)"
          >
            Delete Document
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
